import React from 'react';
import { __ } from 'first-intl';
import { Store } from '../../../store';
import { BonusPoints } from '../../BonusPoints';

export type BonusPointsDetailsStoreProps = { points: BonusPoints };
export type BonusPointsDetailsOwnProps = Record<string, unknown>;
export type BonusPointsDetailsProps = BonusPointsDetailsStoreProps & BonusPointsDetailsOwnProps;

export const UnconnectedBonusPointsDetails: React.FC<BonusPointsDetailsProps> = ({ points }) => (
    <div className="points-status">
        {__('points.show')}
        <span className="points-value icon-loyaltyPoint-white">{points.getFormatted()}</span>
    </div>
);

export const BonusPointsDetails = Store.wire<BonusPointsDetailsStoreProps, BonusPointsDetailsOwnProps>(
    UnconnectedBonusPointsDetails,
    ({ points }) => ({ points })
);
